import { Fragment, PropsWithChildren, useEffect } from "react";
import { Contact } from "../../components/contact/contact";
import { Footer } from "../../components/footer/footer";
import { Hero, HeroProps } from "../../components/hero/hero";

export const Page = ({
	title,
	image,
	children,
}: PropsWithChildren<HeroProps>) => {
	useEffect(() => {
		let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
		if (
			window.matchMedia &&
			window.matchMedia("(prefers-color-scheme: dark)").matches
		) {
			link.href = "icons/favicon-white.svg";
		} else {
			link.href = "icons/favicon-blue.svg";
		}
	});

	return (
		<Fragment>
			<Hero title={title} image={image} />
			{children}
			<Contact />
			<Footer />
		</Fragment>
	);
};
